import React from 'react'
import { PureQueryOptions } from 'apollo-client'
import { Role } from '@contrast-security-inc/base-types'
import { RowActionList } from '../../../legacy-design-system/grid'
import { ModifyVulnerabilityTagsAction } from './tag-action'
import { SendAction } from './send-action'
import { ProtectAction } from './protect-action'
import { DeleteAction } from './delete-action'
import { Vulnerability } from '../cell-renderers/row-action'

interface ActionProps {
  readonly organizationID: string
  readonly applicationRole: Role
  readonly refetchQueries: PureQueryOptions[]
  readonly refresh: () => Promise<any>
  readonly vulnerability: Vulnerability
  readonly trackJob: (job: {
    readonly id: string
    readonly progress: number
    readonly total: number
  }) => Promise<void>
  restrictedEditRole?: boolean
}

export function VulnerabilityRowActionList({
  vulnerability,
  applicationRole,
  organizationID,
  refetchQueries,
  refresh,
  trackJob,
  restrictedEditRole
}: ActionProps) {
  const [isRelatedPopoverOpen, setIsRelatedPopoverOpen] = React.useState(false)

  return (
    <React.Fragment>
      {vulnerability.application.licensed && (
        <RowActionList isRelatedPopoverOpen={isRelatedPopoverOpen}>
          <ModifyVulnerabilityTagsAction
            applicationRole={applicationRole}
            organizationID={organizationID}
            vulnerabilities={[vulnerability]}
            refetchQueries={refetchQueries}
            refresh={refresh}
          />
          <ProtectAction
            orgUuid={organizationID}
            appUuid={
              vulnerability?.application?.parentApplicationId ??
              vulnerability?.application?.id
            }
            vuln={vulnerability}
          />
          <SendAction
            organizationID={organizationID}
            vulnerabilities={[vulnerability]}
            applicationRole={applicationRole}
            refetchQueries={refetchQueries}
            setIsRelatedPopoverOpen={setIsRelatedPopoverOpen}
            refresh={refresh}
          />
          <DeleteAction
            organizationID={organizationID}
            vulnerabilities={[vulnerability]}
            refetchQueries={refetchQueries}
            refresh={refresh}
            trackJob={trackJob}
            restrictedEditRole={restrictedEditRole}
          />
        </RowActionList>
      )}
    </React.Fragment>
  )
}
